import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Alert,
  IconButton,
  TextField
} from '@mui/material';
import { Edit, Save, Cancel, Delete } from '@mui/icons-material';
import {
  getCompanies,
  getApps,
  getCompanyApps,
  addCompanyApp,
  deleteCompanyApp,
  updateCompanyApp
} from '../services/api';

const CompanyAppLinkManagement = ({ token }) => {
  const [companies, setCompanies] = useState([]);
  const [appsList, setAppsList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [companyApps, setCompanyApps] = useState([]);
  const [selectedApp, setSelectedApp] = useState('');
  const [error, setError] = useState('');

  const [editingId, setEditingId] = useState(null);
  const [editingMaxUsers, setEditingMaxUsers] = useState('');

  useEffect(() => {
    fetchCompanies();
    fetchApps();
  }, []);

  useEffect(() => {
    if (selectedCompany) fetchCompanyAppsList();
  }, [selectedCompany]);

  const fetchCompanies = async () => {
    try {
      const data = await getCompanies(token);
      setCompanies(data);
    } catch {
      setError('Erro ao buscar empresas');
    }
  };

  const fetchApps = async () => {
    try {
      const data = await getApps(token);
      setAppsList(data);
    } catch {
      setError('Erro ao buscar apps');
    }
  };

  const fetchCompanyAppsList = async () => {
    try {
      const data = await getCompanyApps(token, selectedCompany);
      setCompanyApps(data);
    } catch {
      setError('Erro ao buscar apps da empresa');
    }
  };

  const handleAssignApp = async () => {
    if (!selectedCompany || !selectedApp) {
      setError('Selecione empresa e app');
      return;
    }
    try {
      await addCompanyApp(token, { company_id: selectedCompany, app_id: selectedApp });
      fetchCompanyAppsList();
    } catch {
      setError('Erro ao vincular app');
    }
  };

  const handleRemoveApp = async (id) => {
    try {
      await deleteCompanyApp(token, id);
      fetchCompanyAppsList();
    } catch {
      setError('Erro ao remover vínculo');
    }
  };

  const startEditing = (id, currentMax) => {
    setEditingId(id);
    setEditingMaxUsers(currentMax);
  };

  const cancelEditing = () => {
    setEditingId(null);
    setEditingMaxUsers('');
  };

  const saveEditing = async (id) => {
    try {
      await updateCompanyApp(token, id, { max_users: Number(editingMaxUsers) });
      cancelEditing();
      fetchCompanyAppsList();
    } catch {
      setError('Erro ao atualizar max usuários');
    }
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h5">🔗 Vinculação App–Empresa</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Card sx={{ p: 2, mb: 3 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel>Empresa</InputLabel>
                <Select
                  value={selectedCompany}
                  label="Empresa"
                  onChange={e => setSelectedCompany(e.target.value)}
                >
                  {companies.map(c => (
                    <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel>App</InputLabel>
                <Select
                  value={selectedApp}
                  label="App"
                  onChange={e => setSelectedApp(e.target.value)}
                >
                  {appsList.map(a => (
                    <MenuItem key={a.id} value={a.id}>{a.app_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button variant="contained" onClick={handleAssignApp}>Vincular App</Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {/* <TableCell>Empresa</TableCell> */}
              <TableCell>App</TableCell>
              <TableCell>Max Usuários</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {companyApps.map(ca => (
              <TableRow key={ca.id}>
                {/* <TableCell>{ca.company_name}</TableCell> */}
                <TableCell>{ca.app_name}</TableCell>
                <TableCell>
                  {editingId === ca.id ? (
                    <TextField
                      size="small"
                      value={editingMaxUsers}
                      onChange={e => setEditingMaxUsers(e.target.value)}
                      type="number"
                    />
                  ) : (
                    ca.max_users
                  )}
                </TableCell>
                <TableCell>
                  {editingId === ca.id ? (
                    <>
                      <IconButton onClick={() => saveEditing(ca.id)}>
                        <Save />
                      </IconButton>
                      <IconButton onClick={cancelEditing}>
                        <Cancel />
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <IconButton onClick={() => startEditing(ca.id, ca.max_users)}>
                        <Edit />
                      </IconButton>
                         <IconButton
                            color="error"
                            onClick={() => {
                            if (window.confirm('Confirma remoção deste vínculo?')) {
                                handleRemoveApp(ca.id);
                            }
                            }}
                        >
                            <Delete />
                        </IconButton>
                    </>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default CompanyAppLinkManagement;
